import React from 'react';
import PropTypes from 'prop-types';
import { Row } from 'react-flexbox-grid';

// import { dimensions } from 'styles/provider';
// dimensions.documentHeaderHeight

const DocumentHeaderRow = ({ children, ...other }) => (
  <Row center="xs" start="sm" middle="xs" style={{ height: 'auto' }} children={children} {...other} />
);

DocumentHeaderRow.propTypes = {
  children: PropTypes.node,
};

export default DocumentHeaderRow;
